<template>
  <div>
    <div class="container_box container_full">
      <div class="search_main_box bg_white mgt10 mgb20">
        <div class="content_article3 userProcol">
            <div class="user_title">用户注册协议</div>
            <div class="title">一、总则</div>
            1.1 日照人力资源产业园的所有权和运营权归日照红柿子科技有限公司所有。 </br>
            1.2 用户在注册之前，应当仔细阅读本协议，并同意遵守本协议后方可成为注册用户。一旦注册成功，则用户与日照人力资源产业园之间自动形成协议关系，用户应当受本协议的约束。 </br>
            1.3 本协议则可由日照人力资源产业园随时更新，用户应当及时关注并同意本站不承担通知义务。本站的通知、公告、声明或其它类似内容是本协议的一部分。</br>
            <div class="title">二、服务内容</div>
            2.1 日照人力资源产业园的具体内容由本站根据实际情况提供。 </br>
            2.2 本站仅提供相关的网络服务，除此之外与相关网络服务有关的设备(如个人电脑、手机、及其他与接入互联网或移动网有关的装置)及所需的费用(如为接入互联网而支付的电话费及上网费、为使用移动网而支付的手机费)均应由用户自行负担。</br>
            <div class="title">三、用户帐号</div>
            3.1 经本站注册系统完成注册程序并通过身份认证的用户即成为正式用户，可以获得本站规定用户所应享有的一切权限. </br>
            3.2 用户只能按照注册要求使用真实姓名，及身份证号注册。用户有义务保证密码和帐号的安全，用户利用该密码和帐号所进行的一切活动引起的任何损失或损害，由用户自行承担全部责任，本站不承担任何责任。如用户发现帐号遭到未授权的使用或发生其他任何安全问题，应立即修改帐号密码并妥善保管，如有必要，请通知本站。因黑客行为或用户的保管疏忽导致帐号非法使用，本站不承担任何责任。</br>
            <div class="title">四、使用规则</div>
            4.1 遵守中华人民共和国相关法律法规，包括但不限于《中华人民共和国计算机信息系统安全保护条例》、《计算机软件保护条例》、《最高人民法院关于审理涉及计算机网络著作权纠纷案件适用法律若干问题的解释(法释[2004]1号)》、《全国人大常委会关于维护互联网安全的决定》、《互联网电子公告服务管理规定》、《互联网新闻信息服务管理规定》、《互联网著作权行政保护办法》和《信息网络传播权保护条例》等有关计算机互联网规定和知识产权的法律和法规、实施办法。</br> 
            4.2 用户对其自行发表、上传或传送的内容负全部责任，所有用户不得在本站任何页面发布、转载、传送含有下列内容之一的信息，否则本站有权自行处理并不通知用户：</br>
            &nbsp;&nbsp;&nbsp;&nbsp;(1)违反宪法确定的基本原则的； </br>
            &nbsp;&nbsp;&nbsp;&nbsp;(2)危害国家安全，泄漏国家机密，颠覆国家政权，破坏国家统一的；</br> 
            &nbsp;&nbsp;&nbsp;&nbsp;(3)损害国家荣誉和利益的； </br>
            &nbsp;&nbsp;&nbsp;&nbsp;(4)煽动民族仇恨、民族歧视，破坏民族团结的； </br>
            &nbsp;&nbsp;&nbsp;&nbsp;(5)破坏国家宗教政策，宣扬邪教和封建迷信的； </br>
            &nbsp;&nbsp;&nbsp;&nbsp;(6)散布谣言，扰乱社会秩序，破坏社会稳定的；</br>
            &nbsp;&nbsp;&nbsp;&nbsp;(7)散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的； </br>
            &nbsp;&nbsp;&nbsp;&nbsp;(8)侮辱或者诽谤他人，侵害他人合法权益的； </br>
            &nbsp;&nbsp;&nbsp;&nbsp;(9)煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的； </br>
            &nbsp;&nbsp;&nbsp;&nbsp;(10)以非法民间组织名义活动的；</br>
            &nbsp;&nbsp;&nbsp;&nbsp;(11)含有法律、行政法规禁止的其他内容的。</br>
            4.3 用户承诺对其发表或者上传于本站的所有信息(即属于《中华人民共和国著作权法》规定的作品，包括但不限于文字、图片、音乐、电影、表演和录音录像制品和电脑程序等)均享有完整的知识产权，或者已经得到相关权利人的合法授权；如用户违反本条规定造成本站被第三人索赔的，用户应全额补偿本站一切费用(包括但不限于各种赔偿费、诉讼代理费及为此支出的其它合理费用)； </br>
            4.4 当第三方认为用户发表或者上传于本站的信息侵犯其权利，并根据《信息网络传播权保护条例》或者相关法律规定向本站发送权利通知书时，用户同意本站可以自行判断决定删除涉嫌侵权信息，除非用户提交书面证据材料排除侵权的可能性，本站将不会自动恢复上述删除的信息；</br>
            &nbsp;&nbsp;&nbsp;&nbsp;(1)不得为任何非法目的而使用网络服务系统； </br>
            &nbsp;&nbsp;&nbsp;&nbsp;(2)遵守所有与网络服务有关的网络协议、规定和程序； (3)不得利用本站进行任何可能对互联网的正常运转造成不利影响的行为； </br>
            &nbsp;&nbsp;&nbsp;&nbsp;(4)不得利用本站进行任何不利于本站的行为。</br>
            4.5 如用户在使用网络服务时违反上述任何规定，本站有权要求用户改正或直接采取一切必要的措施(包括但不限于删除用户张贴的内容、暂停或终止用户使用网络服务的权利)以减轻用户不当行为而造成的影响。</br>
            <div class="title">五、附则</div>
            5.1 本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律。</br> 
            5.2 如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。</br> 
            5.3 本协议解释权及修订权归日照红柿子科技有限公司所有。</br> 
        </div>
      </div>
    </div>
  
    
  </div>
</template>
<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
export default {
  data() {
    return {
     
    };
  },
  methods: {
   
  },

};
</script>
<style lang="less">
.red {
  color: #f00;
}
</style>



// WEBPACK FOOTER //
// src/pages/user-agree.vue